import React from 'react';
import { useLocation } from 'react-router-dom'
import * as Constants from '../../Constants';
// import Footer from '../pageComponents/Footer';
import Navigation from '../pageComponents/Navigation';
import Header from '../pageComponents/Header';
import HansZitko from '../texts/HansZitko';
import TimSommer from '../texts/TimSommer';
import ConstanzeTreuner from '../texts/ConstanzeTreuner';
import SimoneTippachSchneider from '../texts/SimoneTippachSchneider';
import './TextPage.scss';


const TextPage = () => {
    const location = useLocation();
    let component;

    switch(location.pathname){
        case Constants.HANS_ZITKO_ROUTE:
            component = <HansZitko />;
            break;
        case Constants.TIM_SOMMER_ROUTE:
            component = <TimSommer />;
            break;
        case Constants.CONSTANZE_TREUNER_ROUTE:
            component = <ConstanzeTreuner />;
            break;
        case Constants.SIMONE_TIPPACH_SCHNEIDER_ROUTE:
            component = <SimoneTippachSchneider />;
            break;


        default:
            break;
    }
    console.log(component);
    return (
        <>
            <Header />
            <Navigation/>
            <div className='text-holder main'>
                {component}
            </div>
            {/* <Footer /> */}
        </>
    );
};

export default TextPage;